import React, { useEffect, useState, useRef, createElement } from 'react';
import { PlayIcon, PauseIcon, StarIcon, CheckCircle2 } from 'lucide-react';
declare global {
  interface Window {
    checkoutElements: any;
  }
}
function TestimonialAudio() {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const toggle = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (isPlaying) audio.pause();else audio.play().catch(() => {});
  };
  const formatTime = (s: number) => {
    if (!isFinite(s)) return '0:00';
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return `${m}:${sec.toString().padStart(2, '0')}`;
  };
  const remaining = duration - currentTime;
  return <div className="bg-card border border-gold/30 rounded-2xl overflow-hidden shadow-[0_0_30px_rgba(212,175,55,0.1)]" data-id="element-0">
      {/* Large photo */}
      <div className="w-full aspect-[4/3] overflow-hidden" data-id="element-1">
        <img src="https://cdn.magicpatterns.com/uploads/1ftnP3LpwEF49U8TBg58BJ/d572e191-5699-4ad8-b085-20ec91ed7356.png" alt="Rodrigo G. en su comercio" className="w-full h-full object-cover" data-id="element-2" />
      </div>

      {/* Content */}
      <div className="p-5 flex flex-col gap-4" data-id="element-3">
        {/* Stars */}
        <div className="flex gap-1 text-gold text-lg" data-id="element-4">
          <span data-id="element-5">★</span>
          <span data-id="element-6">★</span>
          <span data-id="element-7">★</span>
          <span data-id="element-8">★</span>
          <span data-id="element-9">★</span>
        </div>

        {/* Quote headline */}
        <h3 className="text-white text-lg font-black leading-tight uppercase tracking-tight" data-id="element-10">
          "Al principio desconfiaba de esta idea, pero terminó siendo un
          golazo."
        </h3>

        {/* Name */}
        <p className="text-gray-400 text-sm font-medium -mt-2" data-id="element-11">
          — Rodrigo G., comerciante
        </p>

        {/* Incentive copy */}
        <p className="text-sky-400 text-base font-bold leading-snug" data-id="element-12">
          🎧 Dale play y escuchá en sus propias palabras:
        </p>

        {/* Audio player */}
        <div className="bg-dark border border-gold/20 rounded-xl p-4 flex items-center gap-3" data-id="element-13">
          <button onClick={toggle} aria-label={isPlaying ? 'Pausar audio' : 'Reproducir audio'} className="w-12 h-12 rounded-full bg-gold hover:bg-gold/90 transition-colors flex items-center justify-center shrink-0" data-id="element-14">
            {isPlaying ? <PauseIcon className="w-5 h-5 text-dark" fill="currentColor" data-id="element-15" /> : <PlayIcon className="w-5 h-5 text-dark ml-0.5" fill="currentColor" data-id="element-16" />}
          </button>

          <div className="flex-1 min-w-0 flex flex-col gap-2" data-id="element-17">
            <div className="flex items-center justify-between" data-id="element-18">
              <span className="text-white text-sm font-bold flex items-center gap-1.5" data-id="element-19">
                <span className="text-gold" data-id="element-20">🔊</span> Nota de voz
              </span>
              <span className="text-gray-400 text-xs font-mono" data-id="element-21">
                -{formatTime(remaining)}
              </span>
            </div>
            <div className="h-1 bg-gray-700 rounded-full overflow-hidden" data-id="element-22">
              <div className="h-full bg-gold transition-all" style={{
              width: `${progress}%`
            }} data-id="element-23" />
            </div>
          </div>
        </div>

        <audio ref={audioRef} src="https://cdn.magicpatterns.com/uploads/jY4ediuuCqYuYYW1iBfoyA/202605061321.mp4" onPlay={() => setIsPlaying(true)} onPause={() => setIsPlaying(false)} onEnded={() => {
        setIsPlaying(false);
        setProgress(0);
        setCurrentTime(0);
      }} onLoadedMetadata={e => setDuration(e.currentTarget.duration || 0)} onTimeUpdate={e => {
        const a = e.currentTarget;
        setCurrentTime(a.currentTime);
        if (a.duration) setProgress(a.currentTime / a.duration * 100);
      }} data-id="element-24" />
      </div>
    </div>;
}
function TestimonialText() {
  return <div className="bg-card border border-gold/30 rounded-2xl overflow-hidden shadow-[0_0_30px_rgba(212,175,55,0.1)] mt-6" data-id="element-25">
      {/* Large photo */}
      <div className="w-full aspect-[4/3] overflow-hidden" data-id="element-26">
        <img src="https://cdn.magicpatterns.com/uploads/8emDRtn5mADEbBubQHh2LN/33ddf2bb-6778-425c-8567-88e4be907614.png" alt="Mario P. en su comercio" className="w-full h-full object-cover" data-id="element-27" />
      </div>

      {/* Content */}
      <div className="p-5 flex flex-col gap-4" data-id="element-28">
        {/* Stars */}
        <div className="flex gap-1 text-gold text-lg" data-id="element-29">
          <span data-id="element-30">★</span>
          <span data-id="element-31">★</span>
          <span data-id="element-32">★</span>
          <span data-id="element-33">★</span>
          <span data-id="element-34">★</span>
        </div>

        {/* Quote headline */}
        <h3 className="text-white text-lg font-black leading-tight uppercase tracking-tight" data-id="element-35">
          "Chusmeando un poco lo que me mandaron al correo, ya tengo 2 que voy a
          lanzar a vender junto con las cartas del mundial!!! contento"
        </h3>

        {/* Name */}
        <p className="text-gray-400 text-sm font-medium -mt-2" data-id="element-36">
          — Mario P., comerciante
        </p>
      </div>
    </div>;
}
function ReviewForm() {
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  return <div className="flex flex-col gap-6" data-id="element-37">
      <h2 className="text-white text-3xl font-black text-center uppercase tracking-tight" data-id="element-38">
        ¡DEJÁ TU RESEÑA!
      </h2>

      <div className="bg-[#131722] border border-sky-900/30 rounded-xl p-6 flex flex-col gap-5" data-id="element-39">
        {/* Rating */}
        <div className="flex flex-col gap-2" data-id="element-40">
          <label className="text-gray-300 text-sm font-medium" data-id="element-41">
            Tu calificación
          </label>
          <div className="flex gap-1" data-id="element-42">
            {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" className="focus:outline-none transition-transform hover:scale-110" onMouseEnter={() => setHoveredRating(star)} onMouseLeave={() => setHoveredRating(0)} onClick={() => setRating(star)} data-id="element-43">
                <StarIcon className={`w-8 h-8 ${star <= (hoveredRating || rating) ? 'text-gray-400 fill-gray-400' : 'text-gray-600'} transition-colors`} strokeWidth={1.5} data-id="element-44" />
              </button>)}
          </div>
        </div>

        {/* Name */}
        <div className="flex flex-col gap-2" data-id="element-45">
          <label className="text-gray-300 text-sm font-medium" data-id="element-46">Tu nombre</label>
          <input type="text" placeholder="Ej: Martín S." className="bg-[#0B0E14] border border-gray-800 rounded-lg px-4 py-3 text-white placeholder:text-gray-500 focus:outline-none focus:border-sky-500/50 transition-colors" data-id="element-47" />
        </div>

        {/* Review */}
        <div className="flex flex-col gap-2" data-id="element-48">
          <label className="text-gray-300 text-sm font-medium" data-id="element-49">Tu reseña</label>
          <textarea placeholder="¿Qué te pareció el producto? ¿Cómo quedó impreso?" rows={4} className="bg-[#0B0E14] border border-gray-800 rounded-lg px-4 py-3 text-white placeholder:text-gray-500 focus:outline-none focus:border-sky-500/50 transition-colors resize-none" data-id="element-50" />
        </div>

        {/* Submit Button */}
        <button className="w-full bg-[#8C7A3E] hover:bg-[#9D8A46] text-dark font-bold text-sm py-4 rounded-lg uppercase tracking-widest transition-colors mt-2" data-id="element-51">
          PUBLICAR RESEÑA
        </button>
      </div>
    </div>;
}
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://checkout.hotmart.com/lib/hotmart-checkout-elements.js';
    script.async = true;
    script.onload = () => {
      if (window.checkoutElements) {
        window.checkoutElements.init('salesFunnel').mount('#hotmart-sales-funnel');
      }
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="min-h-screen bg-gray-50 w-full flex justify-center font-sans" data-id="element-52">
      <div className="w-full max-w-md relative pb-24 bg-white shadow-2xl" data-id="element-53">
        {/* TOP ANNOUNCEMENT BAR */}
        <div className="bg-[#E63946] w-full py-2 px-4 text-center" data-id="element-54">
          <p className="text-white font-bold text-[11px] sm:text-xs leading-tight tracking-wide uppercase" data-id="element-55">
            ⚠️ NO CIERRES ESTA PÁGINA - ESTA OFERTA ES ÚNICA Y DESAPARECERÁ PARA
            SIEMPRE
          </p>
        </div>

        {/* SCARCITY HEADER */}
        <div className="bg-dark px-5 py-6 text-center flex flex-col items-center border-b-4 border-sky-500" data-id="element-56">
          <h2 className="text-yellow-400 text-4xl font-black tracking-tight mb-4" data-id="element-57">
            ⚠️ ¡ESPERÁ!
          </h2>

          <div className="w-full max-w-[280px]" data-id="element-58">
            <div className="flex justify-between text-white text-xs font-bold mb-1.5" data-id="element-59">
              <span data-id="element-60">Tu pedido está completado al 50%...</span>
              <span data-id="element-61">50%</span>
            </div>
            <div className="w-full h-3 bg-gray-800 rounded-full overflow-hidden border border-gray-700" data-id="element-62">
              <div className="h-full bg-sky-500 w-1/2 rounded-full relative overflow-hidden" data-id="element-63">
                <div className="absolute inset-0 bg-white/20 animate-[shimmer_2s_infinite] -skew-x-12 translate-x-[-100%]" data-id="element-64" />
              </div>
            </div>
          </div>
        </div>

        {/* MAIN HEADLINE & PRICE */}
        <section className="px-5 pt-8 pb-6 text-center" data-id="element-65">
          <h1 className="text-gray-900 text-3xl sm:text-4xl font-black leading-[1.15] tracking-tight mb-2 uppercase" data-id="element-66">
            VENDÉ LO QUE TODOS BUSCAN, ANTES DE QUE TODOS LO TENGAN.
          </h1>
          <h2 className="text-[#E63946] text-xl sm:text-2xl font-extrabold leading-snug mb-4" data-id="element-67">
            Sumá el Pase VIP al Club de Tendencias por única vez.
          </h2>
          <p className="text-gray-700 text-lg font-medium mb-6 leading-relaxed" data-id="element-68">
            ¿Qué vas a vender cuando termine el Mundial? Asegurá hoy tu
            suministro infinito de productos de alta rotación.
          </p>
          <div className="inline-block bg-yellow-100 border-2 border-yellow-300 rounded-xl px-5 py-3 shadow-sm" data-id="element-69">
            <p className="text-gray-800 text-lg font-medium" data-id="element-70">
              Precio regular{' '}
              <span className="line-through text-gray-500" data-id="element-71">$45.550</span>
              <br data-id="element-72" />
              Agregalo hoy por solo{' '}
              <span className="text-[#E63946] font-black text-2xl" data-id="element-73">
                $32.112
              </span>
            </p>
          </div>
        </section>

        {/* HERO IMAGE */}
        <section className="px-5 pb-8 flex justify-center" data-id="element-74">
          <div className="w-full sm:w-[95%] rounded-xl overflow-hidden shadow-[0_10px_30px_rgba(0,0,0,0.15)] border border-gray-200" data-id="element-75">
            <img src="https://cdn.magicpatterns.com/uploads/8yiAAyVF8Fc9Yy9jx4PKcG/c309ddc3-c47c-4a41-bd22-ba1ebc1ab0e5.png" alt="Club de Tendencias" className="w-full h-auto block" data-id="element-76" />
          </div>
        </section>

        {/* VALUE STACK */}
        <section className="px-5 pb-10" data-id="element-77">
          <div className="bg-white border-2 border-sky-500 rounded-xl p-5 shadow-lg" data-id="element-78">
            <h3 className="text-gray-900 text-xl font-black mb-4 flex items-center gap-2 uppercase" data-id="element-79">
              <span data-id="element-80">📦</span> ¿Qué incluye tu Pase VIP?
            </h3>
            <ul className="flex flex-col gap-4" data-id="element-81">
              <li className="flex items-start gap-3" data-id="element-82">
                <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-83" />
                <p className="text-gray-800 font-bold leading-snug text-base" data-id="element-84">
                  <span className="text-sky-600" data-id="element-85">50 productos nuevos</span>{' '}
                  durante el año — subidos mes a mes.
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-86">
                <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-87" />
                <p className="text-gray-800 font-bold leading-snug text-base" data-id="element-88">
                  <span className="text-sky-600" data-id="element-89">Tendencias fijas</span> — San
                  Valentín, Pascua, Día del Padre, Halloween, Navidad.
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-90">
                <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-91" />
                <p className="text-gray-800 font-bold leading-snug text-base" data-id="element-92">
                  <span className="text-sky-600" data-id="element-93">Tendencias inesperadas</span> —
                  el próximo Mundial, series virales, el meme del momento.
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-94">
                <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-95" />
                <p className="text-gray-800 font-bold leading-snug text-base" data-id="element-96">
                  <span className="text-sky-600" data-id="element-97">
                    Archivos listos para imprimir
                  </span>{' '}
                  en alta calidad.
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-98">
                <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-99" />
                <p className="text-gray-800 font-bold leading-snug text-base" data-id="element-100">
                  <span className="text-sky-600" data-id="element-101">Prioridad en soporte</span> y
                  pedidos personalizados.
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-102">
                <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-103" />
                <p className="text-gray-800 font-bold leading-snug text-base" data-id="element-104">
                  <span className="text-sky-600" data-id="element-105">
                    Mismo modelo que las cartas:
                  </span>{' '}
                  imprimí barato, revendé con +75% de margen.
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-106">
                <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-107" />
                <p className="text-gray-800 font-bold leading-snug text-base" data-id="element-108">
                  <span className="text-[#E63946] uppercase" data-id="element-109">Pago único</span> —
                  sin suscripción, sin mensualidades, acceso para siempre.
                </p>
              </li>
            </ul>

            {/* SPECIAL BONUS */}
            <div className="mt-6 bg-yellow-50 border-2 border-yellow-400 rounded-xl p-4 shadow-sm relative overflow-hidden" data-id="element-110">
              <div className="absolute top-0 right-0 bg-yellow-400 text-yellow-900 text-[10px] font-black px-2 py-1 rounded-bl-lg uppercase tracking-widest animate-pulse" data-id="element-111">
                BONO GRATIS
              </div>
              <h4 className="text-gray-900 text-lg font-black mb-2 flex items-center gap-2" data-id="element-112">
                <span data-id="element-113">🎁</span> Calculadora de Costos
              </h4>
              <p className="text-gray-700 text-sm font-medium leading-relaxed" data-id="element-114">
                Te entregamos la herramienta exacta para que sepas peso por peso
                cuánto te cuesta imprimir y cuánto neto te queda en el bolsillo.{' '}
                <span className="font-bold text-gray-900" data-id="element-115">
                  (¡Tabla de Excel que calcula por vos los costos!)
                </span>
              </p>
            </div>
          </div>
        </section>

        {/* HOTMART SALES FUNNEL */}
        <section className="px-5 py-8 bg-gray-50 border-y border-gray-200" data-id="element-116">
          <div id="hotmart-sales-funnel" data-id="element-117"></div>

          {/* TRUST SIGNALS */}
          <div className="flex justify-center items-center gap-4 mt-8" data-id="element-118">
            <div className="flex flex-col items-center justify-center gap-1 bg-green-50 border border-green-200 px-4 py-3 rounded-xl shadow-sm w-1/2" data-id="element-119">
              <span className="text-3xl" data-id="element-120">🛡️</span>
              <span className="text-[11px] font-black text-green-700 uppercase tracking-wider text-center leading-tight" data-id="element-121">
                Garantía
                <br data-id="element-122" />7 Días
              </span>
            </div>
            <div className="flex flex-col items-center justify-center gap-1 bg-blue-50 border border-blue-200 px-4 py-3 rounded-xl shadow-sm w-1/2" data-id="element-123">
              <span className="text-3xl" data-id="element-124">🔒</span>
              <span className="text-[11px] font-black text-blue-700 uppercase tracking-wider text-center leading-tight" data-id="element-125">
                Seguridad
                <br data-id="element-126" />
                Bancaria
              </span>
            </div>
          </div>
        </section>

        {/* DARK SECTION WRAPPER FOR REST OF CONTENT */}
        <div className="bg-dark pt-12" data-id="element-127">
          {/* SECTION 7: TESTIMONIALS */}
          <section className="px-5 pb-10" data-id="element-128">
            <TestimonialAudio data-id="element-129" />
            <TestimonialText data-id="element-130" />
          </section>

          {/* SECTION 8: REVIEW FORM */}
          <section className="px-5 pb-16" data-id="element-131">
            <ReviewForm data-id="element-132" />
          </section>
        </div>
      </div>
    </div>;
}